'use strict';

let dw = 0;

class MobileNav {

  constructor() {

    let that = this;
    this.resize();
    this.updateNav();

    $('header .hamburger').bind('click', function () {
      that.switchNav();
    });

    $(window).bind('resize', function () {
      that.resize();
      that.updateNav();
    });
  }

  updateNav() {
    if (dw < 994) {
      //mobile
      $('.menu-item-has-children').each(function () {

        let item = $(this);

        $(this).find('span').bind('click', function (e) {
          e.preventDefault();
          let sub = item.find('.sub-menu')
          if (sub.hasClass('open')) {
            sub.removeClass('open');
          } else {
            sub.addClass('open');
          }
        })

        /*   $(this).find('a').unbind().bind('mouseenter', function(e) {
             e.preventDefault()
           })

           $(this).find('a').unbind().bind('mouseleave', function(e) {
             e.preventDefault()
           })

           $(this).find('a').unbind().bind('click', function(e){
             e.preventDefault()
           })*/

        // $(this).find('a').unbind().bind('click', function(e){
        //   e.preventDefault()
        //   let sub = item.find('.sub-menu')
        //   if(sub.hasClass('open')){
        //     sub.removeClass('open')
        //   }else{
        //     sub.addClass('open')
        //   }
        // })
      })
    } else {
      //desktop
      $('.menu-item-has-children').each(function () {
        $(this).find('a').unbind('click');
        $(this).find('a').unbind('mouseenter');
        $(this).find('a').unbind('mouseleave');
      });
    }
  }
  resize() {

    dw = $(document).width();

  }

  switchNav() {
    if ($('.nav-primary').hasClass('active')) {
      $('.nav-primary').removeClass('active');
    } else {
      $('.nav-primary').addClass('active');
      $('.wrap.container').bind('click', function () {
        $('.nav-primary').removeClass('active');
        $('.wrap.container').unbind('click');
      });
    }
  }

}

export default MobileNav;



// WEBPACK FOOTER //
// ./scripts/mobilenav/mobilenav.js